import { configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import reducer from "../reducers";

const whitelist = ["user", "theme", "language"];

// const rememberMe = localStorage.get("remember");

// if (rememberMe) whitelist.push("auth");

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  whitelist
};

const persistedReducer = persistReducer(persistConfig, reducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    }).concat()
});

export const persistor = persistStore(store);
